import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Logo from './Logo'
import Icon from './Icon'
import { TOOLS, ORDER_IMG, ORDER_PDF, ICN, GRAD } from '../data/tools'

function ToolItem({ id, onPick }) {
  return (
    <div className="mega-item" onClick={() => onPick(id)}>
      <span className="mi" style={{ background: GRAD[id] }}>
        <Icon name={ICN[id]} size={16} stroke={2} />
      </span>
      <span className="mn">{TOOLS[id].name}</span>
    </div>
  )
}

function MegaMenu({ cat, onPick }) {
  if (cat === 'all') {
    return (
      <div className="mega all">
        <div className="mega-sec">
          <div className="mega-h"><span className="mega-dot img" />Image tools</div>
          <div className="mega-grid img">{ORDER_IMG.map((id) => <ToolItem key={id} id={id} onPick={onPick} />)}</div>
        </div>
        <div className="mega-sec">
          <div className="mega-h"><span className="mega-dot pdf" />PDF tools</div>
          <div className="mega-grid pdf">{ORDER_PDF.map((id) => <ToolItem key={id} id={id} onPick={onPick} />)}</div>
        </div>
      </div>
    )
  }
  const ids = cat === 'img' ? ORDER_IMG : ORDER_PDF
  return (
    <div className="mega">
      <div className={'mega-grid ' + cat}>
        {ids.map((id) => <ToolItem key={id} id={id} onPick={onPick} />)}
      </div>
    </div>
  )
}

function Navbar() {
  const navigate = useNavigate()
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const [open, setOpen] = useState(null) // 'img' | 'pdf' | null
  const menuRef = useRef(null)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    const onClick = (e) => {
      if (
        menuRef.current &&
        !e.target.closest('#mobileMenu') &&
        !e.target.closest('.menu-toggle')
      )
        setMenuOpen(false)
    }
    document.addEventListener('click', onClick)
    return () => document.removeEventListener('click', onClick)
  }, [])

  const go = (path) => {
    setMenuOpen(false)
    setOpen(null)
    navigate(path)
  }
  const openTool = (id) => {
    setOpen(null)
    navigate('/tool/' + id)
  }

  return (
    <>
      <header className={'nav' + (scrolled ? ' scrolled' : '')}>
      <div className="wrap nav-inner">
        <Logo />
        <nav className="links">
          <div className="nav-dd" onMouseEnter={() => setOpen('all')} onMouseLeave={() => setOpen(null)}>
            <a onClick={() => go('/#tools')}>
              All Tools
              <Icon name="chevron-right" size={14} className="dd-caret" />
            </a>
            {open === 'all' && <MegaMenu cat="all" onPick={openTool} />}
          </div>
          <div className="nav-dd" onMouseEnter={() => setOpen('img')} onMouseLeave={() => setOpen(null)}>
            <a onClick={() => go('/#image')}>
              Image tools
              <Icon name="chevron-right" size={14} className="dd-caret" />
            </a>
            {open === 'img' && <MegaMenu cat="img" onPick={openTool} />}
          </div>
          <div className="nav-dd" onMouseEnter={() => setOpen('pdf')} onMouseLeave={() => setOpen(null)}>
            <a onClick={() => go('/#pdf')}>
              PDF tools
              <Icon name="chevron-right" size={14} className="dd-caret" />
            </a>
            {open === 'pdf' && <MegaMenu cat="pdf" onPick={openTool} />}
          </div>
          <a onClick={() => go('/about')}>About</a>
          <a onClick={() => go('/privacy')}>Privacy Policy</a>
          <a
            className="btn btn-primary"
            style={{ padding: '9px 18px', fontSize: 14, borderRadius: 10 }}
            onClick={() => go('/contact')}
          >
            Contact
          </a>
        </nav>
        <div className="nav-cta">
          <button
            className="menu-toggle"
            aria-label="Menu"
            onClick={(e) => {
              e.stopPropagation()
              setMenuOpen((v) => !v)
            }}
          >
            <Icon name="menu" size={20} stroke={1.8} />
          </button>
        </div>
      </div>
      </header>

      {/* mobile offcanvas (rendered outside the blurred header) */}
      {menuOpen && (
        <>
          <div className="offcanvas-backdrop" onClick={() => setMenuOpen(false)} />
          <aside className="offcanvas" id="mobileMenu" ref={menuRef}>
            <div className="offcanvas-head">
              <Logo />
              <button className="offcanvas-close" aria-label="Close menu" onClick={() => setMenuOpen(false)}>
                <Icon name="x" size={20} stroke={1.9} />
              </button>
            </div>
            <nav className="offcanvas-links">
              <a onClick={() => go('/#tools')}>All Tools</a>
              <a onClick={() => go('/#image')}>Image tools</a>
              <a onClick={() => go('/#pdf')}>PDF tools</a>
              <a onClick={() => go('/about')}>About</a>
              <a onClick={() => go('/privacy')}>Privacy Policy</a>
              <a className="btn btn-primary" onClick={() => go('/contact')}>Contact</a>
            </nav>
          </aside>
        </>
      )}
    </>
  )
}

export default Navbar
